import styles from "../../styles/StartupPotential/StartupPotential.module.css";

const InsightComponent = ({ insight }) => {
  return (
    <div className={styles.InsightComponentContainer}>
      <div>
        <img className={styles.InsightComponentContainerImg} src={insight.src} alt="icon" height={52} width={52} />
      </div>
      <div className={styles.InsightComponentContainerDesc}>
        {insight.desc.map((line, index) => (
          <div key={index}>
            {line}
            {index < insight.desc.length - 1 && <br />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InsightComponent;
